import { type FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Layout } from '../../../../components/Layout';
import { mortgageCalculatorSelector } from '../../../../selectors/mortgageCalculator/mortgageCalculatorSelector';
import { useApplicationContext } from '../../../../utils/applicationContext';
import {
  type IMortgageCalculatorContext,
  MortgageCalculatorContextProvider,
} from '../../contexts/MortgageCalculatorContext';
import type { TFiltersDefaults } from '../../types/filtersDefaults';
import { MortgageSectionContainer } from '../MortgageSection';

export const MortgageCalculator: FC = () => {
  const { config, logger } = useApplicationContext();

  const mortgageCalculator = useSelector(mortgageCalculatorSelector);

  const context = useMemo<IMortgageCalculatorContext | null>((): IMortgageCalculatorContext | null => {
    if (mortgageCalculator) {
      const filtersDefaults = config.get<TFiltersDefaults>('mortgage-calculator.filtersDefaults');

      if (!filtersDefaults) {
        logger.error(
          'RS "mortgage-calculator.filtersDefaults" не была найдена, нужно её добавить, без неё не будет отображаться калькулятор ипотеки',
          { domain: 'src/shared/packages/mortgage-calculator/components/MortgageCalculator/MortgageCalculator.tsx' },
        );

        return null;
      }

      return {
        banks: mortgageCalculator.banks,
        filtersDefaults,
        fromDeveloperMaxPrice: mortgageCalculator.fromDeveloperMaxPrice ?? filtersDefaults.maxPrice,
        fromDeveloperMinPrice: mortgageCalculator.fromDeveloperMinPrice ?? filtersDefaults.minPrice,
        mortgagePromos: mortgageCalculator.mortgagePromos,
        mortgageSeoPageUrl: mortgageCalculator.mortgageSeoPageUrl,
      };
    }

    return null;
  }, [config, logger, mortgageCalculator]);

  if (!context) {
    return null;
  }

  return (
    <Layout>
      <MortgageCalculatorContextProvider value={context}>
        <MortgageSectionContainer />
      </MortgageCalculatorContextProvider>
    </Layout>
  );
};
